export default {
  List: "/tcs/schema",
  Create: "/tcs/schema",
  Detail: "/tcs/schema",
  Update: "/tcs/schema",
  Delete: "/tcs/schema",
  OptionList: "/tcs/schema/dropdown",
};
